import type { ModernSubscription } from '../../types';
import { PlanTypes } from '../../types';

export function isModernProfessionalPlan(modernSubscription: ModernSubscription) {
  const { planType } = modernSubscription;
  if (planType === null || planType === undefined) {
    return false;
  }
  return [PlanTypes.PROFESSIONAL, PlanTypes.PROFESSIONAL2021].includes(planType);
}
